import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {useMediaQuery} from 'react-responsive';
import ToogleMenuList from "../../../../../../../../ui/ToogleMenuList";

const styles = theme => ({
  container: {
    marginLeft: 30
  },
  link: {
    fontSize: 12,
    textDecorationLine: "underline",
    color: "#007FBD",
    marginRight: 16,
    cursor: 'pointer',
  }
});

const EmployeeFilters = ({
  classes,
  returnFilter
}) => {
  /*const isMedium = useMediaQuery({maxWidth: 1024});
  const isLarge = useMediaQuery({minWidth: 1440});
  const isSmall = useMediaQuery({maxWidth: 774});*/

  return (
    <div className={classes.container}>
      <span className={classes.link} onClick={() => returnFilter("all")}>Все</span>
      <span className={classes.link} onClick={() => returnFilter("registered")}>Зарегистрированные</span>
      <span className={classes.link} onClick={() => returnFilter("fired")}>Уволенные</span>
  </div>
  );
};

export default withStyles(styles)(EmployeeFilters);
